import React from "react";
import Cookies from "universal-cookie";
import { Route, Redirect } from "react-router-dom";

export default ({
  component: Component,
  loggedInStatus,
  verified,
  ...rest
}) => {
  const cookies = new Cookies();
  return (
    <Route
      {...rest}
      render={(props) =>
        cookies.get("userLoggedIn") ? (
          <Component {...props} verified={verified} />
        ) : (
          <Redirect
            to={{
              pathname: "/sign-in",
              state: {
                from: props.location,
              },
            }}
          />
        )
      }
    />
  );
};
